import { logger } from './logger';

// 缓存过期时间（毫秒），设为12小时
export const CACHE_EXPIRY = 60 * 60 * 1 * 1000;

// 从缓存获取数据
export const getFromCache = (key) => {
  try {
    const cachedData = localStorage.getItem(key);
    if (!cachedData) return null;
    
    const { data, timestamp } = JSON.parse(cachedData);
    const now = new Date().getTime();
    
    // 检查缓存是否过期
    if (now - timestamp < CACHE_EXPIRY) {
      return data;
    }
    return null;
  } catch (err) {
    logger.error('从缓存获取数据失败:', err);
    return null;
  }
};

// 保存数据到缓存
export const saveToCache = (key, data) => {
  try {
    // 保存新数据
    const cacheData = {
      data,
      timestamp: new Date().getTime()
    };
    localStorage.setItem(key, JSON.stringify(cacheData));
    
    // 清理其他过期缓存（可选，每10次保存执行一次）
    if (Math.random() < 0.1) {
      cleanExpiredCache();
    }
    
    return true;
  } catch (err) {
    logger.error('保存数据到缓存失败:', err);
    return false;
  }
};

// 清理所有过期缓存的辅助函数
const cleanExpiredCache = () => {
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    try {
      const item = localStorage.getItem(key);
      const parsed = JSON.parse(item);
      if (parsed.timestamp && new Date().getTime() - parsed.timestamp > CACHE_EXPIRY) {
        localStorage.removeItem(key);
      }
    } catch (e) {
      // 忽略非JSON格式的项
    }
  }
};

// 新增：带自定义过期时间的缓存获取函数
export const getFromCacheE = (key) => {
  try {
    const cachedData = localStorage.getItem(key);
    if (!cachedData) return null;
    
    const { data, timestamp, expiry } = JSON.parse(cachedData);
    const now = new Date().getTime();
    
    // 缓存过期时间（天数转为毫秒）
    const expiryTime = expiry ? (expiry * 24 * 60 * 60 * 1000) : CACHE_EXPIRY;
    
    // 检查缓存是否过期
    if (now - timestamp < expiryTime) {
      return data;
    }
    return null;
  } catch (err) {
    logger.error('从缓存获取数据失败:', err);
    return null;
  }
};

// 新增：带自定义过期时间的缓存保存函数
export const saveExpiryToCache = (key, data, expiry) => {
  try {
    // 保存新数据，包含自定义过期天数
    const cacheData = {
      data,
      timestamp: new Date().getTime(),
      expiry: expiry // 缓存过期天数：1表示1天，3表示3天等
    };
    localStorage.setItem(key, JSON.stringify(cacheData));
    
    // 清理其他过期缓存（可选，每10次保存执行一次）
    if (Math.random() < 0.1) {
      cleanExpiredCacheE();
    }
    
    return true;
  } catch (err) {
    logger.error('保存数据到缓存失败:', err);
    return false;
  }
};

// 清理所有过期缓存，考虑自定义过期时间
const cleanExpiredCacheE = () => {
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    try {
      const item = localStorage.getItem(key);
      const parsed = JSON.parse(item);
      
      if (parsed.timestamp) {
        // 获取过期时间（天数转毫秒）
        const expiryTime = parsed.expiry 
          ? (parsed.expiry * 24 * 60 * 60 * 1000) 
          : CACHE_EXPIRY;
          
        // 检查是否过期
        if (new Date().getTime() - parsed.timestamp > expiryTime) {
          localStorage.removeItem(key);
        }
      }
    } catch (e) {
      // 忽略非JSON格式的项
    }
  }
};

// 新增：永久保存缓存（不带过期时间）
export const savePermanentCache = (key, data) => {
  try {
    const cacheData = {
      data,
      timestamp: new Date().getTime(),
      permanent: true // 标记为永久缓存
    };
    localStorage.setItem(key, JSON.stringify(cacheData));
    return true;
  } catch (err) {
    logger.error('保存永久缓存失败:', err);
    return false;
  }
};

// 新增：获取永久缓存
export const getPermanentCache = (key) => {
  try {
    const cachedData = localStorage.getItem(key);
    if (!cachedData) return null;
    
    const parsed = JSON.parse(cachedData);
    return parsed.data || null;
  } catch (err) {
    logger.error('获取永久缓存失败:', err);
    return null;
  }
};

// 新增：删除特定缓存
export const removeCache = (key) => {
  try {
    localStorage.removeItem(key);
    return true;
  } catch (err) {
    logger.error('删除缓存失败:', err);
    return false;
  }
}; 